import { render } from "./AppLayoutAdmin.vue?vue&type=template&id=76132214"
import script from "./AppLayoutAdmin.vue?vue&type=script&lang=js"
export * from "./AppLayoutAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__